import ObserverComponent from "./components/observer";

function ObserverPage(): JSX.Element {
  return <ObserverComponent />;
}

export default ObserverPage;
